import "./MagicBagPackHeader.scss";
import backSvg from "../../../../appAssets/svg/back.svg";

interface MagicBagPackHeaderProps {
  titleText: string;
  onBack: () => void;
}

function MagicBagPackHeader({ titleText, onBack }: MagicBagPackHeaderProps) {
  return (
    <div className="mbp-header">
      {/* Green back arrow — top-left */}
      <button
        type="button"
        className="mbp-header__back"
        onClick={onBack}
        aria-label="Back"
      >
        <img
          src={backSvg}
          alt="Back"
          style={{ width: "52px", height: "52px" }}
        />
      </button>

      {/* Title — centered */}
      <h1 className="mbp-header__title">{titleText}</h1>

      {/* Spacer to keep title visually centered */}
      <div className="mbp-header__spacer" />
    </div>
  );
}

export default MagicBagPackHeader;
